module.exports = __webpack_public_path__ + "Roboto-Regular.b2a6341ae7440130ec4b.woff2";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Regular.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Regular.woff2
// module chunks = 5